import {
	SearchNodeModel,
	ScopeSearchNodeModel
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { AlertManager, useAlerts } from "client/Hooks";
import { useSearchNodesStore } from "./useSearchNodesStore";
import { shallowComparison } from "client/Misc/compareUtils";
import { useEffect, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { SearchNodeKind } from "client/Api/SearchSettings/searchSettings";
import { never } from "client_legacy/ndaw/errors";

export type SearchNodesModel = {
	nodes: readonly SearchNodeModel[];
	allAvailableScopes: readonly ScopeSearchNodeModel[];
};

export function useSearchNodes(): SearchNodesModel {
	const alertManager: AlertManager = useAlerts();

	const {
		state,
		fetch
	} = useSearchNodesStore(
		(x) => ({
			state: x.state,
			fetch: x.fetch
		}),
		shallowComparison
	);

	useEffect(
		(): void => {
			fetch({
				onError: () => {
					alertManager.showError(localize("_GeneralErrorMessage"));
				}
			});
		},
		[alertManager, fetch]
	);

	return useMemo(
		(): SearchNodesModel => {
			return {
				nodes: state,
				allAvailableScopes: getScopes(state)
			};
		},
		[state]
	);
}

function getScopes(
	nodes: readonly SearchNodeModel[]
): readonly ScopeSearchNodeModel[] {
	let result: ScopeSearchNodeModel[] = [];

	for (const node of nodes) {
		switch (node.kind) {
			case SearchNodeKind.Scope:
				result.push(node);
				break;
			case SearchNodeKind.Group:
				result = [
					...result,
					...node.scopes
				];
				break;
			default:
				never(node);
		}
	}

	return result;
}
